import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
  FormArray,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import {
  DialogService,
  DynamicDialogRef,
  DynamicDialogConfig,
  DynamicDialogModule,
} from 'primeng/dynamicdialog';
import { StepsModule } from 'primeng/steps'; // Import StepsModule
import { InputTextModule } from 'primeng/inputtext';
import { DatePicker } from 'primeng/datepicker';
import { Select } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag'; // Import TagModule
import { ConfirmationService, MessageService, MenuItem } from 'primeng/api';
import {
  Subscription,
  forkJoin,
  Observable,
  tap,
  catchError,
  of,
  take,
  finalize,
} from 'rxjs';
import { MatriculaService } from '../../api/services';
import {
  dateRangeValidator,
  formatPhoneNumber,
  idadeMinimaValidator,
} from '@validators/date-range.validator';
import { ChangeDetectorRef } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import {
  CommunicationService,
  PaisService,
  ProvinciaService,
  MunicipioService,
  BolseiroService,
  InstituicaoEnsinoCursoService,
  InstituicaoEnsinoService,
  AreaProgramaFormacaoService,
  AreaFormacaoService,
  TipoPedidoService,
  InstituicaoGestoraService,
  BolsaService,
  ProgramaFormacaoService,
  BolsaInstituicaoCursoService,
  EnumService,
  RegraPagamentoService,
  RegraPagamentoSubsidioService,
  EntidadeSeguroService,
} from '../../api/services';
import { AuthService } from '@core/service/auth.service';
import { Utilizador } from '../../api/models/utilizador.model';
import { Bolseiro } from '../../api/models/bolseiro.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService } from '@core/providers/http';
import { DropdownModule } from 'primeng/dropdown';
import { StepperModule } from 'primeng/stepper';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormGroup } from '@angular/forms';
import { FaseCursoService } from '../../api/services/fase-curso.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { InputMaskModule } from 'primeng/inputmask';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { TableComponent } from '@app/shared/components/table/table.component';
import { Pagination } from '../../../../../shared/model/pagination.model';
import { TableColumn } from '../../../../../shared/components/table/table.component';
import { formatISO, isValid, parse, parseISO } from 'date-fns';
import { parseAndFormatDate } from '@core/helpers';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
@Component({
  selector: 'app-cadastrar-auxilio-formacao',
  imports: [
    ReactiveFormsModule,
    DialogModule,
    Select,
    InputTextModule,
    ButtonModule,
    StepperModule,
    StepsModule,
    DatePicker,
    CommonModule,
    FormsModule,
    TableModule,
    DynamicDialogModule,
    CalendarModule,
    DropdownModule,
    TagModule, // Add TagModule to imports,
    RadioButtonModule,
    InputNumberModule,
    ConfirmDialogModule,
    ToastModule,
    InputMaskModule,
    DataVoidComponent,
    SearchBarComponent,
    TableComponent,
    BackButtonComponent,
  ],
  providers: [
    DialogService,
    DynamicDialogRef,
    DynamicDialogConfig,
    MessageService,
    PaisService,
    ProvinciaService,
    MunicipioService,
    CommunicationService,
    BolseiroService,
    AuthService,
    InstituicaoGestoraService,
    InstituicaoEnsinoCursoService,
    InstituicaoEnsinoService,
    ApiService,
    AreaFormacaoService,
    AreaProgramaFormacaoService,
    ProgramaFormacaoService,
    TipoPedidoService,
    FaseCursoService,
    BolsaService,
    ConfirmationService,
    BolsaInstituicaoCursoService,
    EnumService,
    RegraPagamentoService,
    RegraPagamentoSubsidioService,
    EntidadeSeguroService,
    MatriculaService,
  ],
  templateUrl: './cadastrar-auxilio-formacao.component.html',
  styleUrl: './cadastrar-auxilio-formacao.component.scss',
  standalone: true,
})
export class CadastrarAuxilioFormacaoComponent implements OnInit, OnDestroy {
  dialogService = inject(DialogService);
  messageService = inject(MessageService);
  paisService = inject(PaisService);
  provinciaService = inject(ProvinciaService);
  municipioService = inject(MunicipioService);
  communicationService = inject(CommunicationService);
  bolseiroService = inject(BolseiroService);
  instituicaoEnsinoCursoService = inject(InstituicaoEnsinoCursoService);
  instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  regraPagamentoService = inject(RegraPagamentoService);
  regraPagamentoSubsidioService = inject(RegraPagamentoSubsidioService);
  areaFormacaoService = inject(AreaFormacaoService);
  areaProgramaFormacaoService = inject(AreaProgramaFormacaoService);
  tipoPedidoService = inject(TipoPedidoService);
  bolsaService = inject(BolsaService);
  confirmationService = inject(ConfirmationService);
  bolsaInstituicaoCursoService = inject(BolsaInstituicaoCursoService);
  matriculaService = inject(MatriculaService);
  isLoading: boolean = false;
  private location = inject(Location);
  getAllRegraPagamentoLoading: boolean = false;
  private router = inject(Router);
  allCountries: any[] = [];
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  bolseiros: Bolseiro[] = [];
  utilizadores: Utilizador[] = [];
  private subscriptions = new Subscription();
  instituicaoCursoList: any[] = [];
  educationalInstitution: any[] = [];
  areaFormacaoList: any[] = [];
  areaProgramaFormacaoList: any[] = [];
  today: Date = new Date();
  currentEditIndex: any = null;
  numeroBI: any = null;
  matricula: any;
  nivelAcademicoOptions: any[] = [];
  tipoBolsaOptions: any[] = [];
  private cdr = inject(ChangeDetectorRef);
  tipoPedidoOptions: any[] = [];
  empresaGestoraOptions: any[] = [];
  allEmpresaGestoraOptions: any[] = [];
  programaFormacaoOptions: any[] = [];
  listaFases: any[] = [];

  rowIndex: number = 0;
  ativatedRoute = inject(ActivatedRoute);
  faseCursoService = inject(FaseCursoService);
  private authService = inject(AuthService);
  private instituicaoGestoraService = inject(InstituicaoGestoraService);
  private entidadeSeguradoraService = inject(EntidadeSeguroService);
  private programaFormacaoService = inject(ProgramaFormacaoService);
  private fb = inject(FormBuilder);
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  activeStep: number = 1;
  personalInfoForm: FormGroup = new FormGroup({});
  aidForm: FormGroup = new FormGroup({});
  institutionForm: FormGroup = new FormGroup({});
  editMatriculaForm: FormGroup = new FormGroup({});
  instituicoes: FormArray = this.fb.array([]);
  visible: boolean = false;
  visibleEditMatricula: boolean = false;
  bolseiro: any;
  private enumService = inject(EnumService);
  isInternalChange: boolean = false;
  isEditMode: boolean = false;
  auxilioFormacaoId: any = 0;
  auxilioFormacao: any;
  estadoOptions: any[] = [];
  minDate: Date | undefined;
  maxDate: Date | undefined;
  yearRange: string = '';
  periodoPagamentoOptions = [
    { value: 'Mensal', label: 'Mensal' },
    { value: 'Trimestral', label: 'Trimestral' },
  ];
  columns: TableColumn[] = [
    {
      field: 'instituicaoGestoraNome',
      header: 'Instituição Gestora',
      type: 'text',
      tooltip: 'Instituição responsável pela bolsa',
    },
    // {
    //   field: 'programaDesignacao',
    //   header: 'Programa',
    //   type: 'text',
    //   tooltip: 'Nome do programa',
    // },
    {
      header: 'Fase de formação',
      field: 'faseDesignacao',
      type: 'text',
      tooltip: 'Fase de formação',
    },
    {
      field: 'cursoDesignacao',
      header: 'Curso',
      type: 'text',
      tooltip: 'Curso vinculado à bolsa',
    },
    {
      header: 'Instituição de Ensino',
      valueGetter: (row) => {
        const nome = row?.instituicaoEnsinoNome ?? '';
        const sigla = row?.unidadeOrganica ?? '';
        return sigla ? `${sigla} - ${nome}` : nome;
      },
      type: 'text',
      tooltip: 'Nome da instituição de ensino',
    },
    {
      field: 'aproveitamentoLabel',
      header: 'Aproveitamento',
      type: 'tag',
      severityField: 'aproveitamentoLabel',
      tagSeverityFunction: (rowData: any) =>
        this.getSeverity(rowData.aproveitamentoLabel),
      tooltip: 'Status do aproveitamento',
    },
    // {
    //   field: 'isNew',
    //   header: '',
    //   type: 'tag',
    //   tagSeverityFunction: (row) => (row.isNew ? 'info' : 'secondary'),
    //   formatter: (val) => (val ? 'Novo' : '-'),
    // },
  ];
  bolsa: any;
  pagination: Pagination<any> = new Pagination<any>();
  actions: MenuItem[] = [
    {
      label: 'Editar matrícula',
      icon: 'pi pi-pencil',
      command: ($event: any) =>
        this.editBolsaInstituicaoCurso($event.item.data),
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      command: ($event: any) =>
        this.confirmDeleteBolsaInstituicaoCurso($event.item.data),
    },
  ];
  listaUnidadesOrganicas: any[] = [];
  categoriaOptions: any[] = [];
  regraPagamentoOptions: any[] = [];
  RegraPagamentoSubsidioOptions: any[] = [];
  tipoInstituicaoOptions: any[] = [];
  encargosFinanceiros: FormArray = this.fb.array([]);
  anoCurricularOptions: Array<{ label: string; value: number }> = [];
  private isPatchingInstForm = false;
  private currentEditId: number | null = null;
  constructor() {
    // this.getAllInstituicaoGestora();
    // this.getAllInstituicoesEnsino();
    // this.getAllAreaFormacao();
    // this.getAllTipoPedido();
    // this.getAllProgramaFormacao();

    this.getAllRegraPagamento();
    this.personalInfoForm = this.fb.group({
      numeroBI: ['', Validators.required],
      nome: [{ value: '', disabled: true }, Validators.required],
      dataEmissaoBI: [{ value: '', disabled: true }, Validators.required],
      dataVencimentoBI: [{ value: '' }, Validators.required],
      dataNascimento: [
        { value: '', disabled: true },
        [Validators.required, idadeMinimaValidator(15)],
      ],
      estadoCivil: [{ value: '', disabled: true }, Validators.required],
      genero: [{ value: '', disabled: true }, Validators.required],
      nivelAcademico: ['1', Validators.required],
      nomeMae: [{ value: '', disabled: true }, Validators.required],
      nomePai: [{ value: '', disabled: true }, Validators.required],
      idProvinciaResidencia: ['', Validators.required],
      idMunicipioResidencia: ['', Validators.required],
      idMunicipioNascimento: ['1', Validators.required],
      contactoPrincipal: ['', Validators.required],
      enderecoResidencia: [{ value: '', disabled: true }],
      endereco: [{ value: '', disabled: true }],
      email: ['', [Validators.email]],
      contactoFamiliar: ['', Validators.required],
      contactoSecundario: [''],
      isActive: [true, Validators.required],
    });

    this.aidForm = this.fb.group(
      {
        id: ['0'],
        pedidoID: [0, Validators.required],
        bolseiroID: ['', Validators.required],
        dataPedido: ['', Validators.required],
        dataAtribuicao: ['', Validators.required],
        nifRequerente: ['', Validators.required],
        requerenteID: [0],
        nomeRequerente: [{ value: '', disabled: true }, Validators.required],
        emailRequerente: [''],
        isActive: [true, Validators.required],
        telefoneRequerente: ['', Validators.required],
        tipoPedidoID: ['', Validators.required],
        tipoBolsa: [
          {
            value: '',
            disabled: true,
          },
          Validators.required,
        ],
        paisID: ['', Validators.required],
        instituicaoGestoraID: ['', Validators.required],
        nivelAcademico: ['', Validators.required],
        areaProgramaFormacaoID: [4],
        perfilEstudante: ['', Validators.required],
        programaFormacaoID: ['', Validators.required],
        // areaFormacaoID: ['', Validators.required],
        dataInicio: ['', Validators.required],
        dataFim: ['', Validators.required],
        anoCurricularFrequencia: [
          '1',
          [Validators.required, Validators.min(1), Validators.max(6)],
        ],
        regraPagamentoID: [{ value: '', disabled: true }, Validators.required],
        categoriaID: [''],
        descricaoCategoria: [{ value: '', disabled: true }],
        Subsidio: [{ value: '', disabled: true }],
        valorSubsidio: [{ value: '', disabled: true }],
        moedaSubsidio: [{ value: '', disabled: true }],
        periodoPagamentoSubsidio: [{ value: null, disabled: true }],

        possuiSeguroSaude: [null], // valor: true (sim) | false (não)
        entidadeSeguradoraID: [''],
        valorAnualSeguro: [''],
        moedaSeguro: [''],

        encargosFinanceiros: this.fb.array([]),
      },
      {
        validators: [
          dateRangeValidator('dataInicio', 'dataFim', 'dataInicioFimRange'),
          dateRangeValidator(
            'dataPedido',
            'dataAtribuicao',
            'dataPedidoAtribuicaoRange',
          ),
        ],
      },
    );

    this.institutionForm = this.fb.group(
      {
        bolsaID: [this.auxilioFormacaoId, Validators.required],
        instituicao: ['', Validators.required],
        instituicaoCursoID: ['', Validators.required],
        faseCursoID: ['', Validators.required],
        unidadeOrganicaID: [''],
        dataInicio: ['', Validators.required],
        dataFim: [''],
        anoCurricular: ['', Validators.required],
        aproveitamento: [1, Validators.required],
        duracao: [{ value: '', disabled: true }, Validators.required],
      },
      {
        validators: dateRangeValidator(
          'dataInicio',
          'dataFim',
          'dataInicioFimRange',
        ),
      },
    );

    this.editMatriculaForm = this.fb.group(
      {
        bolsaID: [this.auxilioFormacaoId, Validators.required],
        instituicao: [{ value: null, disabled: true }, Validators.required],
        instituicaoCursoID: [
          { value: null, disabled: true },
          Validators.required,
        ],
        faseCursoID: [{ value: null, disabled: true }, Validators.required],
        unidadeOrganicaID: [{ value: null, disabled: true }],
        dataInicio: ['', Validators.required],
        dataFim: [''],
        anoCurricular: ['', Validators.required],
        aproveitamento: [{ value: 1, disabled: true }, Validators.required],
        duracao: [{ value: '', disabled: true }, Validators.required],
      },
      {
        validators: dateRangeValidator(
          'dataInicio',
          'dataFim',
          'dataInicioFimRange',
        ),
      },
    );

    this.aidForm.controls['tipoPedidoID'].valueChanges.subscribe(
      (tipoPedidoID) => {
        const fields = [
          'nifRequerente',
          'nomeRequerente',
          'emailRequerente',
          'telefoneRequerente',
        ];
        const getFallbackValue = (
          formControlName: string,
          fallbackForm: FormGroup,
          fallbackControl: string,
        ) =>
          this.aidForm.get(formControlName)?.value ||
          fallbackForm.get(fallbackControl)?.value ||
          '';

        if (tipoPedidoID === 8) {
          this.aidForm.patchValue({
            nifRequerente: getFallbackValue(
              'nifRequerente',
              this.personalInfoForm,
              'numeroBI',
            ),
            nomeRequerente: getFallbackValue(
              'nomeRequerente',
              this.personalInfoForm,
              'nome',
            ),
            emailRequerente: getFallbackValue(
              'emailRequerente',
              this.personalInfoForm,
              'email',
            ),
            telefoneRequerente: this.personalInfoForm.value.contactoPrincipal,
          });

          fields.forEach((field) => this.aidForm.get(field)?.disable());
        } else {
          fields.forEach((field) => this.aidForm.get(field)?.enable());

          if (!this.isInternalChange) {
            this.aidForm.patchValue({
              nifRequerente: '',
              nomeRequerente: '',
              telefoneRequerente: '',
              emailRequerente: '',
            });
          }
        }
        this.aidForm.get('nomeRequerente')?.disable();
      },
    );

    this.aidForm.controls['paisID'].valueChanges.subscribe((paisID) => {
      this.entidadesSeguradorasOptions = [];
      if (paisID) {
        this.getAllEntidadeSeguradora(paisID);
        this.autoSelectRegraPagamento();
      }
    });

    this.aidForm
      .get('possuiSeguroSaude')
      ?.valueChanges.subscribe((possuiSeguro: boolean) => {
        if (possuiSeguro === false) {
          this.aidForm.get('entidadeSeguradoraID')?.disable();
          this.aidForm.get('valorAnualSeguro')?.disable();
          this.aidForm.get('moedaSeguro')?.disable();
        } else {
          this.aidForm.get('entidadeSeguradoraID')?.enable();
          this.aidForm.get('valorAnualSeguro')?.enable();
          this.aidForm.get('moedaSeguro')?.enable();
        }
      });

    this.aidForm.controls['regraPagamentoID'].valueChanges.subscribe(
      (value) => {
        if (value) {
          // this.getAllRegraPagamentoSubsidioByRegraPagamento(value);
        } else {
          this.RegraPagamentoSubsidioOptions = [];
        }
      },
    );

    this.aidForm.controls['tipoBolsa'].valueChanges.subscribe((tipoBolsa) => {
      this.onTipoBolsaChange(tipoBolsa);
      // this.autoSelectRegraPagamento();
      this.handleFaseCursoByTipoBolsa(tipoBolsa);
    });

    // Inicializa também no carregamento
    setTimeout(() => {
      this.handleFaseCursoByTipoBolsa(this.aidForm.get('tipoBolsa')?.value);
    });

    this.aidForm.controls['perfilEstudante'].valueChanges.subscribe(() => {
      this.autoSelectRegraPagamento();
    });

    this.aidForm.controls['nivelAcademico'].valueChanges.subscribe(() => {
      this.autoSelectRegraPagamento();
    });

    this.aidForm.controls['nivelAcademico'].valueChanges.subscribe(() => {
      this.autoSelectRegraPagamento();
    });

    this.aidForm.controls['programaFormacaoID'].valueChanges.subscribe(
      (value) => {
        this.areaProgramaFormacaoList = [];
        this.onProgramaFormacaoChange(value);
      },
    );

    this.editMatriculaForm.controls['dataFim'].valueChanges.subscribe(
      (value) => {
        const dataInicio = this.institutionForm.get('dataInicio')?.value;
        const dataFim = value ? new Date(value) : null;

        if (!dataInicio || !dataFim) {
          this.institutionForm.patchValue({
            duracao: 0,
          });
          return;
        }

        const diffTime = Math.abs(
          dataFim.getTime() - new Date(dataInicio).getTime(),
        );
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        const years = Math.floor(diffDays / 365);
        const months = Math.floor((diffDays % 365) / 30);
        const days = Math.floor((diffDays % 365) % 30);

        let duration = '';
        if (years > 0) {
          duration += `${years} ano${years > 1 ? 's' : ''}`;
        }
        if (months > 0) {
          if (duration) duration += ', ';
          duration += `${months} mês${months > 1 ? 'es' : ''}`;
        }
        if (days > 0) {
          if (duration) duration += ' e ';
          duration += `${days} dia${days > 1 ? 's' : ''}`;
        }
        if (!duration) {
          duration = `${diffDays} dia${diffDays > 1 ? 's' : ''}`;
        }

        this.institutionForm.patchValue({
          duracao: duration || 0,
        });
      },
    );

    this.institutionForm.controls['dataFim'].valueChanges.subscribe((value) => {
      const dataInicio = this.institutionForm.get('dataInicio')?.value;
      const dataFim = value ? new Date(value) : null;

      if (!dataInicio || !dataFim) {
        this.institutionForm.patchValue({
          duracao: 0,
        });
        return;
      }

      const diffTime = Math.abs(
        dataFim.getTime() - new Date(dataInicio).getTime(),
      );
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      const years = Math.floor(diffDays / 365);
      const months = Math.floor((diffDays % 365) / 30);
      const days = Math.floor((diffDays % 365) % 30);

      let duration = '';
      if (years > 0) {
        duration += `${years} ano${years > 1 ? 's' : ''}`;
      }
      if (months > 0) {
        if (duration) duration += ', ';
        duration += `${months} mês${months > 1 ? 'es' : ''}`;
      }
      if (days > 0) {
        if (duration) duration += ' e ';
        duration += `${days} dia${days > 1 ? 's' : ''}`;
      }
      if (!duration) {
        duration = `${diffDays} dia${diffDays > 1 ? 's' : ''}`;
      }

      this.institutionForm.patchValue({
        duracao: duration || 0,
      });
    });

    this.institutionForm.controls['instituicaoCursoID'].valueChanges.subscribe(
      (cursoId) => {
        console.log('Curso selecionado ID:', cursoId); // DEBUG
        this.computeAnoCurricularOptions(cursoId);
        // sempre que muda curso, limpa/valida o valor atual
        if (!cursoId) this.institutionForm.get('anoCurricular')?.setValue(null);
      },
    );

    this.institutionForm.controls['instituicao'].valueChanges.subscribe(() => {
      if (this.isPatchingInstForm) return; // 👈 evita reset durante patch
      this.listaUnidadesOrganicas = [];
      this.onInstitutionChange(
        this.institutionForm.controls['instituicao'].value,
      );
      this.institutionForm.controls['instituicaoCursoID'].reset();
      this.anoCurricularOptions = [];
      this.institutionForm.get('anoCurricular')?.setValue(null);
    });

    this.institutionForm.controls['faseCursoID'].valueChanges.subscribe(() => {
      if (this.isPatchingInstForm) return; // 👈
      this.onFaseChange(this.institutionForm.controls['faseCursoID'].value);
      this.institutionForm.controls['instituicaoCursoID'].reset();
      this.anoCurricularOptions = [];
      this.institutionForm.get('anoCurricular')?.setValue(null);
    });

    this.institutionForm.controls['unidadeOrganicaID'].valueChanges.subscribe(
      (value) => {
        if (this.isPatchingInstForm) return; // 👈
        this.instituicaoCursoList = [];
        this.anoCurricularOptions = [];
        if (!value) return;
        this.getAllInstituicaoCurso({
          InstituicaoEnsinoID: value || this.institutionForm.value.instituicao,
          CategoriaEnsinoCursoID:
            this.institutionForm.getRawValue().faseCursoID,
          pageSize: 100,
        });
      },
    );
  }

  private getQuantidadeAnosFromCurso(curso: any): number {
    if (
      curso?.planoCurricular &&
      Array.isArray(curso.planoCurricular) &&
      curso.planoCurricular.length
    ) {
      const qtds = curso.planoCurricular
        .map((p: any) => Number(p?.quantidadeAnosCurricular) || 0)
        .filter((n: number) => n > 0);
      if (qtds.length) return Math.max(...qtds);
    }
    // Sem plano → sem dropdown (volta para input manual)
    return 0;
  }

  // --- NEW: gera as opções [1..N] e sincroniza o form
  private computeAnoCurricularOptions(
    cursoId: number | null | undefined,
  ): void {
    // limpa sempre primeiro
    this.anoCurricularOptions = [];
    const ctrl = this.institutionForm.get('anoCurricular');

    if (!cursoId) {
      ctrl?.setValue(null);
      return;
    }

    const cursoSel = this.instituicaoCursoList.find(
      (c: any) => c?.id === cursoId,
    );
    console.log(
      'Curso selecionado:',
      cursoSel,
      this.instituicaoCursoList,
      cursoId,
    ); // DEBUG
    const total = this.getQuantidadeAnosFromCurso(cursoSel);

    if (total > 0) {
      this.anoCurricularOptions = Array.from({ length: total }, (_, i) => ({
        label: `${i + 1}º ano`,
        value: i + 1,
      }));
      const current = ctrl?.value;
      if (!current || current > total) {
        ctrl?.setValue(1); // default para 1º ano
      }
    } else {
      // sem plano → obriga input manual
      ctrl?.setValue(null);
    }
  }

  entidadesSeguradorasOptions = [
    { label: 'ENSA', value: 'ENSA' },
    { label: 'Nossa Seguros', value: 'NOSSA' },
  ];

  aproveitamentoOptions: any[] = [];

  moedasOptions = [
    { label: 'Kwanza Angolano', value: 'AOA' },
    { label: 'Dólar Americano', value: 'USD' },
    { label: 'Euro', value: 'EUR' },
    { label: 'Libra Esterlina', value: 'GBP' },
    { label: 'Franco Suíço', value: 'CHF' },
    { label: 'Iene Japonês', value: 'JPY' },
    { label: 'Dólar Canadense', value: 'CAD' },
    { label: 'Dólar Australiano', value: 'AUD' },
    { label: 'Yuan Chinês', value: 'CNY' },
    { label: 'Real Brasileiro', value: 'BRL' },
    { label: 'Peso Argentino', value: 'ARS' },
    { label: 'Peso Mexicano', value: 'MXN' },
    { label: 'Rublo Russo', value: 'RUB' },
    { label: 'Rupia Indiana', value: 'INR' },
    { label: 'Rand Sul-Africano', value: 'ZAR' },
    { label: 'Dólar de Hong Kong', value: 'HKD' },
    { label: 'Won Sul-Coreano', value: 'KRW' },
    { label: 'Dirham dos Emirados', value: 'AED' },
    { label: 'Rial Saudita', value: 'SAR' },
    { label: 'Dinar Argelino', value: 'DZD' },
    { label: 'Franco CFA BCEAO (África Ocidental)', value: 'XOF' },
    { label: 'Franco CFA BEAC (África Central)', value: 'XAF' },
    { label: 'Dólar de Singapura', value: 'SGD' },
    { label: 'Lira Turca', value: 'TRY' },
    { label: 'Novo Shekel Israelense', value: 'ILS' },
    { label: 'Ringgit Malaio', value: 'MYR' },
  ];
  isLoadingRegrapagamento = false;
  get isExterna(): boolean {
    return (
      this.aidForm.get('tipoBolsa')?.value &&
      this.aidForm.get('tipoBolsa')?.value != 1
    );
  }

  buildEncargosFinanceirosFromRegra(regra: any) {
    const encargosFormArray = this.aidForm.get(
      'encargosFinanceiros',
    ) as FormArray;
    encargosFormArray.clear(); // limpa o array

    if (regra?.regraPagamentoSubsidio?.length) {
      regra.regraPagamentoSubsidio.forEach((subsidio: any) => {
        const group = this.fb.group({
          tipo: [
            { value: subsidio.subsidios?.descricao || '', disabled: true },
          ],
          valor: [{ value: subsidio.valor || 0, disabled: true }],
          moeda: [{ value: subsidio.moeda || 'USD', disabled: true }],
        });
        encargosFormArray.push(group);
      });
    }
  }

  verificarRegraPagamentoEDesenharCampos() {
    const snapshot = this.isEditMode
      ? this.auxilioFormacao
      : this.aidForm.getRawValue(); // <- lê antes

    // evita concorrência
    if (this.isLoadingRegrapagamento) return;

    delete snapshot.dataFim; // <- remove dataFim se existir
    delete snapshot.dataInicio; // <- remove dataInicio se existir
    delete snapshot.request;

    // 1) snapshot IMUTÁVEL antes de mexer no form
    const payload = this.removeEmpty({ ...snapshot });
    console.log('payload', payload, 'snapshot', this.auxilioFormacao); // DEBUG
    // (Opcional) se precisares normalizar tipos/datas para o backend:
    // const payload = this.normalizePayload(snapshot, this.isEditMode);

    this.isLoadingRegrapagamento = true;

    // 2) agora sim: limpar UI sem afetar o payload que já está montado
    this.resetEncargos(); // garanta que isto NÃO reseta campos de topo!
    this.aidForm.controls['regraPagamentoID'].setValue(null, {
      emitEvent: false,
    });

    // 3) chama a API com o payload do snapshot
    this.bolsaService
      .verificarRegraPagamento(payload)
      .pipe(
        take(1),
        finalize(() => {
          this.isLoadingRegrapagamento = false;
        }),
      )
      .subscribe((regra) => {
        // reseta campos de regra (apenas os necessários)
        this.aidForm.patchValue(
          {
            regraPagamentoID: null,
            descricaoCategoria: '',
            Subsidio: '',
            valorSubsidio: 0,
            moedaSubsidio: '',
          },
          { emitEvent: false },
        );

        if (regra) {
          this.aidForm.patchValue(
            { regraPagamentoID: regra.id },
            { emitEvent: false },
          );
          this.buildEncargosFinanceirosFromRegra(regra);
        }
      });
  }

  /**
   * Limpa o array de encargos, o formulário associado e
   * o FormArray antes de qualquer requisição.
   */
  private resetEncargos() {
    // zera APENAS o que é da área de encargos / categoria
    this.aidForm.patchValue(
      {
        descricaoCategoria: '',
        Subsidio: '',
        valorSubsidio: 0,
        moedaSubsidio: '',
      },
      { emitEvent: false },
    );

    // se for um FormArray:
    const fa = this.aidForm.get('encargosFinanceiros');
    if (fa && Array.isArray((fa as any).controls)) {
      (fa as any).clear?.(); // Angular 15+ tem FormArray#clear()
    }
  }

  removeEmpty(obj: any): any {
    if (Array.isArray(obj)) {
      // Filtra elementos vazios em arrays
      return obj
        .map((v) => this.removeEmpty(v))
        .filter(
          (v) =>
            !(
              v === null ||
              v === undefined ||
              v === '' ||
              (typeof v === 'object' && Object.keys(v).length === 0) ||
              (Array.isArray(v) && v.length === 0)
            ),
        );
    } else if (typeof obj === 'object' && obj !== null) {
      // Filtra propriedades vazias em objetos
      return Object.fromEntries(
        Object.entries(obj)
          .map(([k, v]) => [k, this.removeEmpty(v)])
          .filter(
            ([_, v]) =>
              !(
                v === null ||
                v === undefined ||
                v === '' ||
                (typeof v === 'object' && Object.keys(v).length === 0) ||
                (Array.isArray(v) && v.length === 0)
              ),
          ),
      );
    }
    return obj;
  }

  get encargosFinanceirosForm(): FormArray {
    return this.aidForm.get('encargosFinanceiros') as FormArray;
  }

  autoSelectRegraPagamento() {
    this.verificarRegraPagamentoEDesenharCampos();
  }

  autoSetPeriodoPagamento(tipoBolsa: any) {
    if (tipoBolsa == 1) {
      // Interna
      this.aidForm.patchValue({ periodoPagamentoSubsidio: 'Trimestral' });
    } else if (tipoBolsa == 2) {
      // Externa
      this.aidForm.patchValue({ periodoPagamentoSubsidio: 'Mensal' });
    } else {
      this.aidForm.patchValue({ periodoPagamentoSubsidio: null });
    }
  }

  handleFaseCursoByTipoBolsa(tipoBolsa: any) {
    const faseControl = this.institutionForm.get('faseCursoID');
    const faseCurso = this.listaFases.find(
      (f) => f.designacao === 'Ensino Superior',
    );

    if (tipoBolsa == 1) {
      if (faseCurso) {
        faseControl?.enable();
        faseControl?.setValue(faseCurso.id);
        this.institutionForm.patchValue({
          faseCursoID: faseCurso.id,
          // instituicaoCursoID: '',
        });
        faseControl?.disable(); // ← desabilita após setar
      } else {
        console.warn('Fase "Ensino Superior" não encontrada.');
      }
    } else {
      faseControl?.enable();
      faseControl?.setValue(null);
    }

    this.cdr.detectChanges();
  }

  getAllEntidadeSeguradora(value: any) {
    this.entidadeSeguradoraService
      .list({
        pageSize: 100,
        PaisID: value,
      })
      .subscribe((response) => {
        if (response.data) {
          this.entidadesSeguradorasOptions = response.data;
        }
      });
  }

  getAllRegraPagamento() {
    if (this.getAllRegraPagamentoLoading) return;
    this.getAllRegraPagamentoLoading = true;
    this.regraPagamentoService.list({ pageSize: 1000 }).subscribe({
      next: (response) => {
        this.regraPagamentoOptions = response.data;
      },
      error: () => {},
      complete: () => {
        this.getAllRegraPagamentoLoading = false;
      },
    });
  }

  getAllRegraPagamentoSubsidioByRegraPagamento(value: any) {
    this.regraPagamentoSubsidioService
      .list({ RegraPagamentoId: value })
      .subscribe((response) => {
        if (response.data) {
          this.RegraPagamentoSubsidioOptions = response.data;
          this.aidForm.patchValue({
            Subsidio:
              this.RegraPagamentoSubsidioOptions?.[0]?.subsidio.designacao,
            descricaoCategoria:
              this.RegraPagamentoSubsidioOptions?.[0]?.regraPagamento.descricao,
            valorSubsidio:
              this.RegraPagamentoSubsidioOptions?.[0]?.regraPagamento
                .valorPagamento,
            moedaSubsidio:
              this.RegraPagamentoSubsidioOptions?.[0]?.regraPagamento.moeda,
          });
        }
      });
  }

  loadEnums(): Observable<any> {
    return forkJoin({
      tipoBolsa: this.enumService.getAllTipoBolsaEnum(),
      nivelAcademico: this.enumService.getAllNivelAcademicoMIREMPETEnum(),
      perfilEstudante: this.enumService.getAllEnumPerfilEstudanteEnum(),
      estadoBolsa: this.enumService.getAllEstadoBolsaEnum(),
      tipoInstituicao: this.enumService.getAllTipoInstituicaoEnum(),
      estadoBolsaCurso: this.enumService.getAllEstadoBolsaCursoEnum(),
    }).pipe(
      tap((response) => {
        if (response.tipoBolsa?.data) {
          this.tipoBolsaOptions = Object.entries(response.tipoBolsa.data).map(
            ([key, value]) => ({ id: Number(key), designacao: value }),
          );
        }
        if (response.nivelAcademico?.data) {
          this.nivelAcademicoOptions = Object.entries(
            response.nivelAcademico.data,
          ).map(([key, value]) => ({ id: Number(key), label: value }));
        }
        if (response.perfilEstudante?.data) {
          this.categoriaOptions = Object.entries(
            response.perfilEstudante.data,
          ).map(([key, value]) => ({ id: Number(key), designacao: value }));
        }
        if (response.estadoBolsa?.data) {
          this.estadoOptions = Object.entries(response.estadoBolsa.data).map(
            ([key, value]) => ({ id: Number(key), designacao: value }),
          );
        }
        if (response.tipoInstituicao?.data) {
          this.tipoInstituicaoOptions = Object.entries(
            response.tipoInstituicao.data,
          ).map(([key, value]) => ({ id: Number(key), designacao: value }));
        }
        if (response.estadoBolsaCurso?.data) {
          this.aproveitamentoOptions = Object.entries(
            response.estadoBolsaCurso.data,
          )
            .filter(([key]) => key === '1' || key === '2') // apenas "Pendente" e "Em Curso"
            .map(([key, value]) => ({
              id: Number(key),
              designacao: value,
            }));
        }
      }),
    );
  }

  ngOnInit(): void {
    this.getAllFaseCurso();

    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear, 0, 1);
    this.maxDate = new Date(currentYear + 9, 11, 31);
    this.yearRange = `${currentYear}:${currentYear + 9}`;

    forkJoin({
      instituicoes: this.getAllInstituicaoGestora(),
      // instituicoesEnsino: this.getAllInstituicoesEnsino(),
      areas: this.getAllAreaFormacao(),
      tipos: this.getAllTipoPedido(),
      programas: this.getAllProgramaFormacao(),
      enums: this.loadEnums(),
      countries: this.loadCountries(),
      // bolsaCursos: this.loadAllBolsaInstituicaoCurso(),
    }).subscribe(({ instituicoes, countries }) => {
      // 🔁 atribuição redundante, mas garante que valores estejam prontos
      this.empresaGestoraOptions =
        instituicoes?.data || this.allEmpresaGestoraOptions;
      this.countries = countries?.data || this.countries;
      this.allCountries = countries?.data || this.allCountries;
      this.allEmpresaGestoraOptions = instituicoes?.data || [];

      this.ativatedRoute.paramMap.subscribe((params) => {
        const numeroBI = params.get('numeroBI');
        this.auxilioFormacaoId =
          this.ativatedRoute.snapshot.queryParamMap.get('auxilioFormacaoId') ||
          0;
        this.isEditMode = !!this.auxilioFormacaoId;

        if (numeroBI) {
          this.personalInfoForm.controls['numeroBI'].setValue(numeroBI);
          this.searchDocumentNumber();
        } else {
          this.location.back();
        }

        if (this.isEditMode) {
          this.loadAuxilioFormacao(this.auxilioFormacaoId as any);
          this.loadAllBolsaInstituicaoCurso().subscribe();
        }
      });
    });
  }

  handleFormValueChange(event: any) {}

  showDialog(habilitacao?: any) {
    this.visible = true;
  }

  closeDialog() {
    this.visible = false;
  }

  getAllFaseCurso() {
    this.faseCursoService.list().subscribe((response: any) => {
      this.listaFases = response;
      this.handleFaseCursoByTipoBolsa(this.aidForm.get('tipoBolsa')?.value);
    });
  }

  getTipoInstituicaoById(id: number) {
    return this.tipoInstituicaoOptions.find((opt) => opt.id == id);
  }

  onTipoBolsaChange(value: any) {
    if (value == 1) {
      const tipoInterna = this.getTipoInstituicaoById(0);
      this.getAllInstituicoesEnsino(tipoInterna.id);
      this.countries = this.allCountries?.filter(
        (country) => country?.designacao == 'Angola',
      );
      this.aidForm.controls['paisID'].disable();
      this.aidForm.controls['paisID'].setValue(this.countries?.[0]?.id);
      this.empresaGestoraOptions = this.allEmpresaGestoraOptions.filter(
        (empresa) => empresa.id == 3,
      );
      this.aidForm.controls['instituicaoGestoraID'].disable();
      this.aidForm.controls['instituicaoGestoraID'].setValue(3);
      return;
    }

    const { paisID, instituicaoGestoraID } = this.aidForm.value;
    ['paisID', 'instituicaoGestoraID'].forEach((field) => {
      this.aidForm.controls[field].enable();
      this.aidForm.controls[field].setValue(null);
    });
    const tipoExterna = this.getTipoInstituicaoById(1);
    this.getAllInstituicoesEnsino(tipoExterna?.id);

    this.countries = this.allCountries?.filter(
      (country) => country?.designacao !== 'Angola',
    );
    this.aidForm.controls['paisID'].enable();
    this.aidForm.controls['paisID'].setValue(paisID != '193' ? paisID : null);
    this.empresaGestoraOptions = this.allEmpresaGestoraOptions?.filter(
      (empresa) => empresa?.id !== 3,
    );
    this.aidForm.controls['instituicaoGestoraID'].enable();
    const valor =
      instituicaoGestoraID || this.auxilioFormacao?.instituicaoGestora?.id;
    if (valor !== 3) {
      this.aidForm.controls['instituicaoGestoraID'].setValue(valor || '');
    }
  }

  onProgramaFormacaoChange(value: any) {
    if (!value) return;
    const programaFormacao = this.getById(value, this.programaFormacaoOptions);
    const tipoBolsaValue = this.aidForm.controls['tipoBolsa'].value;
    if (programaFormacao) {
      this.aidForm.controls['tipoBolsa'].setValue(
        programaFormacao.tipoProgramaValueEnum || tipoBolsaValue,
      );
    }

    this.getAllAreaProgramaFormacao({
      ProgramaFormacaoId: value,
      pageSize: 1000,
    });
  }

  onInstitutionChange(value: any) {
    this.updateInstituicaoEnsinoCursoControl(value);
    // const faseId = event.value;
    this.getAllInstituicaoCurso({
      InstituicaoEnsinoID: value,
      CategoriaEnsinoCursoID:
        this.institutionForm.controls['faseCursoID'].value,
      pageSize: 1000,
    });
    this.listaUnidadesOrganicas = [];
    this.loadAllUnidadeOrganica(
      value || this.institutionForm.controls['instituicao'].value,
    );
  }

  onFaseChange(value: any) {
    this.updateInstituicaoEnsinoCursoControl(value);
  }

  loadAllUnidadeOrganica(insituicaoEnsinoID: any) {
    this.instituicaoEnsinoService
      .list({ InstituicaoPaiID: insituicaoEnsinoID, pageSize: 1000 })
      .subscribe((res) => {
        this.listaUnidadesOrganicas = res.data.map((item: any) => ({
          ...item,
          id: item?.id,
          designacao: item?.nome,
        }));

        const unidadeControl = this.institutionForm.get('unidadeOrganicaID');
        if (this.listaUnidadesOrganicas.length === 0) {
          unidadeControl?.setValue(null);
          unidadeControl?.disable();
        } else {
          unidadeControl?.enable();
        }
      });
  }

  updateInstituicaoEnsinoCursoControl(event: any) {
    if (this.currentEditIndex !== null) {
      this.institutionForm.controls['instituicaoCursoID'].reset();
    }
    this.instituicaoCursoList = [];
    if (!this.institutionForm.controls['instituicao'].value) {
      this.institutionForm.controls['instituicao'].markAsTouched();
      return;
    }
    if (!this.institutionForm.controls['faseCursoID'].value) {
      this.institutionForm.controls['instituicao'].markAsTouched();
      return;
    }
  }

  getAllInstituicaoCurso(params: any) {
    this.instituicaoCursoList = [];
    this.instituicaoEnsinoCursoService.list(params).subscribe(
      (response) => {
        this.instituicaoCursoList = response.data.map((item: any) => ({
          ...item, // <- mantém planoCurricular aqui
          id: item?.id,
          nome: item?.curso,
        }));
        // --- NEW: se já existe curso escolhido, recalcula as opções
        const selectedId =
          this.institutionForm.get('instituicaoCursoID')?.value;
        if (selectedId) this.computeAnoCurricularOptions(selectedId);
      },
      (error: any) => {
        console.error('Erro ao buscar instituições de curso:', error);
      },
    );
  }

  getById(id?: any, array?: any) {
    return array.find((item: any) => item.id === id);
  }

  getAllInstituicoesEnsino(tipoInstituicaoEnsino: any = null) {
    if (
      [null, undefined, 'null', 'undefined', ''].includes(tipoInstituicaoEnsino)
    )
      return;
    this.instituicaoEnsinoService
      .list({ pageSize: 1000, TipoInstituicao: tipoInstituicaoEnsino })
      .subscribe((institutions) => {
        this.educationalInstitution = institutions.data;
      });
  }

  getAllTipoPedido(): Observable<any> {
    return this.tipoPedidoService.list({ pageSize: 1000 }).pipe(
      tap((response) => {
        this.tipoPedidoOptions = response.data;
      }),
    );
  }

  getAllAreaFormacao(): Observable<any> {
    return this.areaFormacaoService.list({ pageSize: 1000 }).pipe(
      tap((response) => {
        this.areaFormacaoList = response.data;
      }),
    );
  }

  // onAreaFormacaoChange(event: any) {
  //   const areaFormacaoID = event.value;
  //   this.getAllAreaProgramaFormacao({
  //     AreaFormacaoID: areaFormacaoID,
  //     pageSize: 100,
  //   });
  // }

  getAllAreaProgramaFormacao(params: any) {
    this.areaProgramaFormacaoService.list(params).subscribe(
      (response) => {
        this.areaProgramaFormacaoList = response.data.map((item: any) => ({
          ...item,
          id: item?.id,
          designacao: item?.areaFormacao?.designacao,
        }));
      },
      (error: any) => {
        console.error('Erro ao buscar instituições de curso:', error);
      },
    );
  }

  onProvinceChange(event: any) {
    this.communicationService.emitProvinceChanged(event.value);
    this.resetMunicipality();
  }

  onCountryChange(event: any) {
    this.communicationService.emitCountryChanged(event.value);
    this.resetProvinceAndMunicipality();
  }

  resetProvinceAndMunicipality() {
    this.personalInfoForm.patchValue({
      idMunicipioResidencia: null,
      idProvinciaResidencia: null,
    });
  }

  resetMunicipality() {
    this.personalInfoForm.patchValue({
      idMunicipioResidencia: null,
    });
  }

  getAllInstituicaoGestora(): Observable<any> {
    return this.instituicaoGestoraService.list({ pageSize: 1000 }).pipe(
      tap(({ data }) => {
        this.allEmpresaGestoraOptions = data;
        this.empresaGestoraOptions = data;
      }),
    );
  }

  getAllProgramaFormacao(): Observable<any> {
    return this.programaFormacaoService.list({ pageSize: 1000 }).pipe(
      tap(({ data }) => {
        this.programaFormacaoOptions = data;
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadCountries(): Observable<any> {
    return this.paisService.list().pipe(
      tap((response) => {
        this.countries = response; // ← garantir que estás a setar
        this.allCountries = response; // ← garantir que estás a setar
      }),
    );
  }

  loadProvinces(country: string) {
    this.provinciaService.list(country).subscribe((provinces) => {
      this.provinces = provinces;
      this.communicationService.updateProvinces(provinces);
      this.municipalities = []; // Reset municipalities when country changes
    });
  }

  loadMunicipalities(province: string) {
    this.municipioService.list(province).subscribe((municipalities) => {
      this.municipalities = municipalities;
      this.communicationService.updateMunicipalities(municipalities);
    });
  }

  searchDocumentNumber() {
    this.bolseiroService
      .list({ NumeroBI: this.f.numeroBI.value })
      .subscribe((response) => {
        if (response.data.length > 0) {
          this.bolseiro = response.data[0];
          this.personalInfoForm.patchValue({
            ...this.bolseiro,
            nome: this.bolseiro.nome,
            bolseiroID: this.bolseiro.id,
            email: this.bolseiro.email,
            contactoPrincipal:
              this.bolseiro.numeroContacto || this.bolseiro.contactoPrincipal,
          });
          this.aidForm.patchValue({
            bolseiroID: this.bolseiro.id,
          });
        }
      });
  }

  searchDocumentNumberRequerente() {
    this.authService
      .consultarBi(this.f.nifRequerente.value)
      .subscribe((result) => {
        if (result.retorno.codigo == 200 && result.data) {
          this.aidForm.patchValue({
            nomeRequerente: `${result.data.nome} ${result.data.sobrenome}`,
            emailRequerente: result.data.email,
            telefoneRequerente: result.data.numeroContacto,
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail:
              'Não foi possivel encontrar o cidadão requerente com o número do BI fornecido.',
            life: 4000,
          });
        }
      });
  }

  get f(): any {
    return {
      ...this.personalInfoForm.controls,
      ...this.aidForm.controls,
      ...this.institutionForm.controls,
    };
  }

  save() {
    if (this.aidForm.valid) {
      const bolsa = this.aidForm.getRawValue();

      // Formatando campos de data do "bolsa"
      bolsa.dataInicio = parseAndFormatDate(bolsa.dataInicio);
      bolsa.dataFim = parseAndFormatDate(bolsa.dataFim);
      bolsa.dataPedido = parseAndFormatDate(bolsa.dataPedido);
      bolsa.dataAtribuicao = parseAndFormatDate(bolsa.dataAtribuicao);

      const bolsaInstituicaoCursoAdds = (this.pagination.data || []).map(
        (item: any) => ({
          ...item,
          menuActions: [],
          id: item.id || 0,
          aproveitamento: item.aproveitamento || 1,
          instituicaoEnsinoCursoID: item.instituicaoCursoID,
          dataInicio: parseAndFormatDate(item.dataInicio),
          dataFim: parseAndFormatDate(item.dataFim),
          anoCurricular: item.anoCurricular,
        }),
      );

      const formData = {
        bolsa,
        bolsaInstituicaoCursoAdds,
      };

      console.log(formData, 'formData');

      if (this.isEditMode) {
        this.updateAuxilioFormacao(formData);
      } else {
        this.storeBolsa(formData);
      }
    } else {
      this.personalInfoForm.markAllAsTouched?.();
      this.aidForm.markAllAsTouched();
      this.institutionForm.markAllAsTouched();

      this.messageService.add({
        severity: 'warn',
        summary: 'Campos obrigatórios',
        detail:
          'Por favor preencha todos os campos obrigatórios corretamente antes de prosseguir.',
        life: 5000,
      });
    }
  }

  private prepareBolsaData(data: any, isUpdate: boolean = false): any {
    let hasBolsaInstituicaoCursoAdds =
      data?.bolsaInstituicaoCursoAdds?.length > 0;

    if (!hasBolsaInstituicaoCursoAdds) {
      return {
        id: isUpdate ? data.bolsa.id : undefined,
        bolseiroID: data.bolsa.bolseiroID,
        pedidoID: data.bolsa.pedidoID,
        requerenteID: data.bolsa.requerenteID,
        dataPedido: data.bolsa.dataPedido,
        dataAtribuicao: data.bolsa.dataAtribuicao,
        nifRequerente: data.bolsa.nifRequerente,
        nomeRequerente: data.bolsa.nomeRequerente,
        emailRequerente: data.bolsa.emailRequerente,
        isActive: data.bolsa.isActive,
        telefoneRequerente: formatPhoneNumber(data.bolsa.telefoneRequerente),
        tipoPedidoID: data.bolsa.tipoPedidoID,
        tipoBolsa: data.bolsa.tipoBolsa,
        paisID: data.bolsa.paisID,
        perfilEstudante: data.bolsa.perfilEstudante,
        instituicaoGestoraID: data.bolsa.instituicaoGestoraID,
        nivelAcademico: data.bolsa.nivelAcademico,
        areaProgramaFormacaoID: data.bolsa.areaProgramaFormacaoID,
        programaFormacaoID: data.bolsa.programaFormacaoID,
        dataInicio: data.bolsa.dataInicio,
        dataFim: data.bolsa.dataFim,
        estadoBolsa: this.getEstadoByDesignacao('Enquadrado')?.id,
        anoCurricularFrequencia: data.bolsa.anoCurricularFrequencia,
        regraPagamentoID: data.bolsa.regraPagamentoID,
        possuiSeguroSaude: data.bolsa.possuiSeguroSaude,
        entidadeSeguradoraID: data.bolsa.entidadeSeguradoraID,
        valorAnualSeguro: data.bolsa.valorAnualSeguro,
        moedaSeguro: data.bolsa.moedaSeguro,
      };
    }

    return {
      bolsa: {
        ...data.bolsa,
        estadoBolsa: this.getEstadoByDesignacao('Activo')?.id,
      },
      bolsaInstituicaoCursoAdds: data.bolsaInstituicaoCursoAdds,
    };
  }

  private handleSaveOperation(
    saveOperation: any,
    successMessage: string,
    redirectPath: string,
  ): void {
    saveOperation.subscribe({
      next: (response: any) => {
        this.isLoading = false; // Parar carregamento
        switch (response.retorno.codigo) {
          case 200:
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: successMessage,
              life: 3000,
            });
            setTimeout(() => {
              this.router.navigate([
                redirectPath,
                response?.data?.bolseiro?.id || this.f.bolseiroID.value,
              ]);
            }, 1000);
            break;
          case 400:
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail:
                response.retorno.mensagem || 'Erro ao realizar a operação.',
              life: 3000,
            });
            break;
          default:
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro desconhecido ao realizar a operação.',
              life: 3000,
            });
            break;
        }
      },
      error: (err: any) => {
        this.isLoading = false; // Parar carregamento
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail:
            err.error?.retorno?.mensagem || 'Erro ao realizar a operação.',
          life: 3000,
        });
      },
    });
  }

  storeBolsa(data: any): void {
    this.isLoading = true; // Iniciar carregamento
    const preparedData = this.prepareBolsaData(data);
    console.log(preparedData);
    const saveOperation =
      data?.bolsaInstituicaoCursoAdds?.length > 0
        ? this.bolseiroService.storeEstudante(preparedData)
        : this.bolsaService.store(preparedData);

    this.handleSaveOperation(
      saveOperation,
      'O auxílio de formação foi cadastrado com sucesso!',
      '/gestao-bolseiros/bolseiros/detalhe-bolseiro',
    );
  }

  getEstadoByDesignacao(designacao: string) {
    return this.estadoOptions.find((estado) => estado.designacao == designacao);
  }

  updateAuxilioFormacao(data: any): void {
    this.isLoading = true; // Iniciar carregamento
    const preparedData = this.prepareBolsaData(data, true);
    console.log(preparedData);
    const saveOperation =
      data?.bolsaInstituicaoCursoAdds?.length > 0
        ? this.bolsaService.updateBolsaCompleta(
            {
              bolsaInstituicaoCursoAdds: preparedData.bolsaInstituicaoCursoAdds,
              bolsa: {
                ...preparedData.bolsa,
                estadoBolsa: this.getEstadoByDesignacao('Activo')?.id,
              },
            },
            this.auxilioFormacaoId as any,
          )
        : this.bolsaService.update(
            {
              ...preparedData,
              estadoBolsa: this.getEstadoByDesignacao('Enquadrado')?.id,
            },
            this.auxilioFormacaoId as any,
          );

    this.handleSaveOperation(
      saveOperation,
      'O auxílio de formação foi actualizado com sucesso!',
      '/gestao-bolseiros/bolseiros/detalhe-bolseiro',
    );
  }

  loadAllBolsaInstituicaoCurso(queryParams: any = {}): Observable<any> {
    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 5,
      BolsaID: this.auxilioFormacaoId,
      OrderBy: 'id desc',
    };

    return this.bolsaInstituicaoCursoService.list(params).pipe(
      tap((response) => {
        console.log('response loadAllBolsaInstituicaoCurso', response);
        this.pagination = new Pagination<any>().deserialize(response);
      }),
      catchError((err) => {
        console.error('Erro na chamada da bolsaInstituicaoCurso:', err);
        return of(null); // evita quebra
      }),
    );
  }

  editBolsaInstituicaoCurso(row: any) {
    this.visibleEditMatricula = true;
    this.currentEditId = row?.id ?? null; // usar id, não índice
    this.isPatchingInstForm = true;
    console.log(row);
    // 1) patch básico sem eventos
    this.editMatriculaForm.patchValue(
      {
        faseCursoID: row?.faseId,
        instituicao: row.instituicaoEnsinoID,
        unidadeOrganicaID: row?.unidadeOrganicaID ?? null,
        dataInicio: this.formatDateForInput(row?.dataInicio),
        dataFim: this.formatDateForInput(row?.dataFim),
        duracao: row?.duracao ?? '',
        aproveitamento: row?.aproveitamentoID || 1,
      },
      { emitEvent: false },
    );

    this.matriculaService.list({ BolsaInstituicaoCursoID: row?.id }).subscribe({
      next: (res: any) => {
        this.matricula = res[0];
        console.log(this.matricula);
      },
      error: (err) => {
        console.error(err);
      },
    });

    // 2) carregar listas dependentes e depois setar curso/ano
    forkJoin([
      this.instituicaoEnsinoService.list({
        InstituicaoPaiID: row?.instituicaoEnsinoID,
        pageSize: 1000,
      }),
      this.instituicaoEnsinoCursoService.list({
        InstituicaoEnsinoID: row?.instituicaoEnsinoID,
        CategoriaEnsinoCursoID: row?.faseId,
        pageSize: 1000,
      }),
    ])
      .pipe(take(1))
      .subscribe(([uoRes, cursosRes]) => {
        this.listaUnidadesOrganicas = (uoRes?.data ?? []).map((i: any) => ({
          ...i,
          id: i.id,
          designacao: i.nome,
        }));
        this.instituicaoCursoList = (cursosRes?.data ?? []).map((i: any) => ({
          ...i,
          id: i.id,
          nome: i.curso, // mantém planoCurricular!
        }));

        const cursoId =
          row.instituicaoEnsinoCursoID || row.instituicaoCursoID || null;
        console.log('cursoId para computeAnoCurricularOptions:', cursoId);
        this.computeAnoCurricularOptions(cursoId);
        this.editMatriculaForm.patchValue(
          {
            faseCursoID: row?.faseId,
            instituicao: row?.instituicaoEnsinoID,
            instituicaoCursoID: row?.instituicaoEnsinoCursoNome,
            anoCurricular: this.matricula?.anoCurricular ?? null,
          },
          { emitEvent: false },
        );

        this.computeAnoCurricularOptions(cursoId);

        this.isPatchingInstForm = false;
      });
  }

  updateAnoMatricula() {
    if (this.editMatriculaForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Formulário inválido',
        detail: 'Verifique os campos do formulário',
      });
      this.editMatriculaForm.markAllAsTouched();
    }
    const v = this.editMatriculaForm.getRawValue();
    const payload = {
      anoMatricula: String(v?.anoCurricular),
      bolsaInstituicaoCursoId: this.currentEditId,
      dataInicio: new Date(v?.dataInicio),
      dataFim: new Date(v?.dataFim),
    };

    this.matriculaService.trocarAnoLectivoMatricula(payload).subscribe(
      (res) => {
        if (res.retorno.codigo === 200) {
          this.loadAllBolsaInstituicaoCurso();
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Ano da matrícula actualizado com sucesso!',
          });
          this.visibleEditMatricula = false;
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Falha',
            detail:
              `${res.retorno.mensagem}` ||
              'Falha ao actualizar ano da matricula',
          });
        }
      },
      (error) => {
        console.error('Erro ao actualizar ano da matrícula:', error);
        this.visibleEditMatricula = false;
      },
    );
  }

  confirmDeleteBolsaInstituicaoCurso(bolsaInstituicaoCurso: any) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja eliminar esta fase de formação?',
      accept: () => {
        this.deleteBolsaInstituicaoCurso(bolsaInstituicaoCurso?.id);
      },
    });
  }

  deleteBolsaInstituicaoCurso(id: number) {
    this.bolsaInstituicaoCursoService.delete(id as any).subscribe(
      (res) => {
        const ok = res?.retorno?.codigo === 200 || res?.data === true;
        if (!ok) {
          this.messageService.add({
            severity: 'error',
            summary: `Erro ${res?.retorno?.codigo ?? ''}`.trim(),
            detail: 'Erro ao eliminar a Fase de Formação.',
          });
          return;
        }
        this.loadAllBolsaInstituicaoCurso().subscribe();
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Fase de Formação eliminada com sucesso!',
        });
      },
      (error) => {
        console.error('Erro ao eliminar fase de formação:', error);
      },
    );
  }

  onActionSelected(event: any) {
    const { event: actionEvent, rowData } = event;
    this.actions
      .find((action) => action.label === actionEvent.item.label)
      ?.command?.({ item: rowData });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadAllBolsaInstituicaoCurso();
  }

  loadAuxilioFormacao(auxilioFormacaoId: string) {
    this.bolsaService.show(auxilioFormacaoId).subscribe({
      next: (response: any) => {
        if (response.retorno.codigo === 200) {
          const auxilioFormacao = response.data;
          this.auxilioFormacao = auxilioFormacao;
          this.isInternalChange = true;
          this.aidForm.patchValue({
            ...auxilioFormacao,
            perfilEstudante: auxilioFormacao.perfilEstudante || '1',
            requerenteID: +auxilioFormacao.requerenteID,
            telefoneRequerente: auxilioFormacao.telefoneRequerente,
            pedidoID: +auxilioFormacao.pedidoID,
            paisID: +auxilioFormacao.paisID,
            instituicaoGestoraID: +auxilioFormacao.instituicaoGestora?.id,
            dataInicio: parse(
              auxilioFormacao.dataInicio,
              'dd/MM/yyyy',
              new Date(),
            ),
            dataFim: parse(auxilioFormacao.dataFim, 'dd/MM/yyyy', new Date()),
            // dataInicio: new Date(auxilioFormacao.dataInicio),
            // dataFim: new Date(auxilioFormacao.dataFim),
            dataPedido: parseISO(auxilioFormacao.dataPedido),
            dataAtribuicao: parseISO(auxilioFormacao.dataAtribuicao),
            programaFormacaoID:
              +auxilioFormacao?.programaFormacaoId ||
              +auxilioFormacao?.areaProgramaFormacao?.programaFormacao?.id,
            areaProgramaFormacaoID: +auxilioFormacao?.areaProgramaFormacao?.id,
            regraPagamentoID: auxilioFormacao?.regraPagamento?.id,
            possuiSeguroSaude: auxilioFormacao?.possuiSeguroSaude || false,
            entidadeSeguradoraID: auxilioFormacao?.entidadeSeguradoraID || '',
            valorAnualSeguro: auxilioFormacao?.valorAnualSeguro || 0,
            moedaSeguro: auxilioFormacao?.moedaSeguro || 'AOA',
          });
          this.instituicoes.clear();
          auxilioFormacao?.bolsaInstituicaoCursoAdds?.forEach(
            (instituicao: any) => {
              const newInstituicaoGroup = this.fb.group({
                instituicao: [instituicao.instituicao, Validators.required],
                instituicaoCursoID: [
                  instituicao.instituicaoCursoID,
                  Validators.required,
                ],
                cursoNome: [
                  this.getById(
                    instituicao.instituicaoCursoID,
                    this.instituicaoCursoList,
                  )?.nome,
                ],
                dataInicio: [instituicao.dataInicio, Validators.required],
                dataFim: [instituicao.dataFim, Validators.required],
                duracao: [instituicao.duracao, Validators.required],
                bolsaID: [this.auxilioFormacaoId, Validators.required],
              });
              this.instituicoes.push(newInstituicaoGroup);
            },
          );
          this.autoSelectRegraPagamento();
        }
      },
      error: (err: any) => {
        console.error('Erro ao carregar auxílio de formação:', err);
      },
    });
  }

  cancel() {
    this.ref.close();
    this.resetForm();
  }

  resetForm() {
    const tipoBolsa = this.aidForm.get('tipoBolsa')?.value;
    let initial: any = {
      bolsaID: this.auxilioFormacaoId || 0,
      instituicao: null,
      instituicaoCursoID: null,
      faseCursoID: null,
      dataInicio: null,
      dataFim: null,
      duracao: null,
      aproveitamento: 2,
      anoCurricular: null,
    };

    if (tipoBolsa == 1) {
      const faseCurso = this.listaFases.find(
        (f) => f.designacao === 'Ensino Superior',
      );
      if (faseCurso) {
        initial.faseCursoID = faseCurso.id;
      }
    }

    this.institutionForm.reset(initial);
  }

  private formatDateForInput(dateStr: any): Date | null {
    if (!dateStr) return null;

    // Caso já seja Date
    if (dateStr instanceof Date && isValid(dateStr)) {
      return dateStr;
    }

    // Se for string no formato DD/MM/YYYY
    if (typeof dateStr === 'string' && dateStr.includes('/')) {
      const parsed = parse(dateStr, 'dd/MM/yyyy', new Date());
      return isValid(parsed) ? parsed : null;
    }

    // Tenta converter qualquer outra string ou timestamp
    const parsed = new Date(dateStr);
    return isValid(parsed) ? parsed : null;
  }

  hydrateNewItem(raw: any): any {
    return {
      ...raw,
      id: 0,
      bolsaID: this.auxilioFormacaoId || 0,
      cursoDesignacao: this.getById(
        raw.instituicaoCursoID,
        this.instituicaoCursoList,
      )?.nome,
      faseDesignacao: raw?.faseDesignacao,
      instituicaoEnsinoNome: this.getById(
        raw.instituicao,
        this.educationalInstitution,
      )?.nome,
      instituicaoCursoID: raw.instituicaoCursoID,
      instituicaoGestoraNome: 'MIREMPET - DNFCL', // Exemplo fixo ou dinâmico
      anoCurricular: raw?.anoCurricular || null,
    };
  }

  addInstituicaoToTable(item: any) {
    const newItem = {
      ...item,
      id: 0, // indica que ainda não foi salvo
      // isNew: true,
    };

    this.pagination.data = [...(this.pagination.data || []), newItem];
    this.pagination.totalRecords = (this.pagination.totalRecords ?? 0) + 1;
  }

  updateMenuActions() {
    if (this.pagination.data) {
      this.pagination.data = this.pagination.data.map((rowData: any) => ({
        ...rowData,
        menuActions: this.getMenuActions(rowData),
      }));
    }
  }

  addInstituicao() {
    if (this.institutionForm.invalid) {
      this.institutionForm.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Campos obrigatórios',
        detail:
          'Por favor preencha todos os campos obrigatórios corretamente antes de prosseguir.',
        life: 5000,
      });
      return;
    }
    const instituicaoFormValue = this.institutionForm.getRawValue();

    const faseCurso = this.listaFases.find(
      (f) => f.id === instituicaoFormValue.faseCursoID,
    );
    const tipoBolsa = this.aidForm.get('tipoBolsa')?.value;
    const data = this.pagination?.data ?? []; // fallback para array vazio

    // Validação: Bolsa Interna só pode ter uma fase
    if (tipoBolsa == 1 && data.length >= 1 && this.currentEditIndex === null) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Limite atingido',
        detail:
          'Para bolsas internas, apenas é permitida uma única fase de formação.',
        life: 4000,
      });
      return;
    }

    // Validação: Fase já adicionada (para bolsas externas)
    const faseSelecionada = instituicaoFormValue.faseCursoID;
    const aproveitamento = instituicaoFormValue.aproveitamento;

    const faseDuplicada = data.some((item: any, index: number) => {
      if (this.currentEditIndex !== null && item.id === this.currentEditIndex)
        return false;
      return item.faseCursoID === faseSelecionada;
    });

    if (faseDuplicada) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Fase duplicada',
        detail: 'Esta fase de formação já foi adicionada.',
        life: 4000,
      });
      return;
    }

    if (
      aproveitamento == 2 &&
      data.some(
        (item: any) =>
          item.aproveitamento == 2 && this.currentEditIndex === null,
      )
    ) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Aproveitamento em Curso duplicado',
        detail: 'Apenas uma fase pode estar com aproveitamento "Em Curso".',
        life: 4000,
      });
      return;
    }

    const newItem = {
      ...instituicaoFormValue,
      cursoNome: this.getById(
        instituicaoFormValue.instituicaoCursoID,
        this.instituicaoCursoList,
      )?.nome,
      faseDesignacao: faseCurso?.designacao,
      aproveitamentoLabel: this.aproveitamentoOptions.find(
        (opt) => opt.id == aproveitamento,
      )?.designacao,
      id: 0,
      bolsaID: this.auxilioFormacaoId || 0,
      menuActions: this.getMenuActions(instituicaoFormValue),
      anoCurricular: instituicaoFormValue?.anoCurricular,
    };

    console.log(this.auxilioFormacaoId, 'newItem', newItem);
    if (this.currentEditIndex !== null) {
      if (data[this.currentEditIndex]) {
        data[this.currentEditIndex] = {
          ...data[this.currentEditIndex],
          ...newItem,
        };
      }
      this.currentEditIndex = null;
    } else {
      const newItemHydrated = this.hydrateNewItem({
        ...newItem,
      });
      console.log('newItemHydrated', newItemHydrated);
      this.addInstituicaoToTable(newItemHydrated);
      this.updateMenuActions();
    }

    // Resetar o formulário e esconder o modal
    this.institutionForm.reset({
      instituicao: '',
      instituicaoCursoID: '',
      dataInicio: '',
      dataFim: '',
      duracao: '',
      anoCurricular: '',
      unidadeOrganicaID: '',
      faseCursoID: '',
      estado: '',
      bolsaID: this.auxilioFormacaoId || 0,
    });

    this.visible = false;
  }

  getMenuActions(rowData: any): MenuItem[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        command: () => this.editBolsaInstituicaoCurso(rowData),
      },
      {
        label: 'Eliminar',
        icon: 'pi pi-trash',
        command: () => this.confirmDeleteBolsaInstituicaoCurso(rowData),
      },
    ];
  }

  removeInstituicao(index: number) {
    this.instituicoes.removeAt(index);
  }

  getSeverity(aproveitamento: string): any {
    if (!aproveitamento) return 'info'; // Default severity if aproveitamento is undefined or null
    switch (aproveitamento?.toUpperCase()) {
      case 'ATIVO':
        return 'success';
      case 'INATIVO':
        return 'secondary';
      case 'SUSPENSO':
        return 'danger';
      case 'PENDENTE':
        return 'warning';
      case 'ENQUADRADO':
        return 'info';
      case 'EM CURSO':
        return 'info';
      case 'FINALIZADO':
        return 'success';
      case 'REPROVADO':
        return 'danger';
      default:
        return 'info';
    }
  }

  getLabel(status: string) {
    switch (status) {
      case 'Aprovado':
        return 'Aprovado';
      case 'em_curso':
        return 'Em Curso';
      case 'reprovado':
        return 'Reprovado';
      case 'suspensa':
        return 'Suspensa';
      case 'Pendente':
        return 'Pendente';
      default:
        return 'Outro';
    }
  }

  activateCallback(step: number) {
    if (!this.isStepValid(step)) {
      this.markFormAsTouched(step);
    }
    this.activeStep = step;
  }

  isStepValid(step: number): boolean {
    if (step === 1) {
      return this.aidForm.valid;
    } else if (step === 2) {
      return this.instituicoes.valid;
    }
    return true;
  }

  markFormAsTouched(step: number) {
    if (step === 1) {
      this.personalInfoForm.markAllAsTouched();
      this.aidForm.markAllAsTouched();
    } else if (step === 2) {
      this.instituicoes.markAllAsTouched();
    }
  }

  nextStep() {
    this.activeStep++;
  }

  previousStep() {
    if (this.activeStep > 1) {
      this.activeStep--;
    }
  }
}
